export * from './replace.directive';



// WEBPACK FOOTER //
// D:/desv/producao/hc/angular/adminHC/src/app/directives/replace/index.ts